export const CountryCodeToDistrictionChannelMap = {
  US: ['1'], // United States
  JP: ['2'], // Japan
  GB: ['3'], // United Kindom
  AU: ['4'], // Australia
  DE: ['5'], // Germany
  FR: ['6'], // France
  CA: ['7'], // Canada
  SE: ['10'], // Sweden
  NZ: ['11'], // New Zealand
  SG: ['12'], // Singapore
  MY: ['13'], // Malaysia
  AT: ['14'], // Austria
  ES: ['15'], // Spain
  MX: ['17'], // Mexico
  TW: ['18'], // Taiwan
  CN: ['19'], // China
  HK: ['20'], // Hong Kong
  NL: ['21'], // Netherlands
  BR: ['22'], // Brazil
  IT: ['23'], // Italy
  CH: ['24'], // Switzerland
  BE: ['26'], // Belgium
  FI: ['28'], // Finland
  DK: ['29'], // Denmark
  NO: ['30'], // Norway
  ZA: ['31'], // South Africa
  IN: ['32'], // India
  IE: ['35'], // Ireland
  GR: ['39'], // Greece
  AR: ['40'], // Argentina
  CO: ['41'], // Colombia
  CL: ['42'], // Chile
  VE: ['43'], // Venezuela
  PE: ['44'], // Peru
  LU: ['50'], // Luxembourg
  PH: ['51'], // Philippines
  VN: ['52'], // Vietnam
  TH: ['53'], // Thailand
  ID: ['54'], // Indonesia
  BD: ['72'], // Bangladesh
  BO: ['74'], // Bolivia
  CR: ['84'], // Costa Rica
  DO: ['88'], // Dominican Republic
  EC: ['89'], // Ecuador
  SV: ['90'], // El Salvador
  GT: ['95'], // Guatemala
  HT: ['97'], // Haiti
  HN: ['98'], // Honduras
  NP: ['115'], // Nepal
  PA: ['120'], // Panama
  PY: ['121'], // Paraguay
  LK: ['131'], // Sri Lanka
  TT: ['135'], // Trinidad and Tobago
  UY: ['139'], // Uruguay
  TR: ['142'], // Turkey
  PL: ['143'], // Poland - EN
  PT: ['144'], // Portugal - EN
  BG: ['145'], // Bulgaria
  HR: ['146'], // Croatia
  CY: ['147'], // Cyprus
  CZ: ['148'], // Czechia
  EE: ['149'], // Estonia
  HU: ['150'], // Hungary
  LV: ['151'], // Latvia
  LT: ['152'], // Lithuania
  MT: ['153'], // Malta
  RO: ['154'], // Romania
  SK: ['155'], // Slovakia
  SI: ['156'], // Slovenia
  AL: ['157'], // Albania
  AD: ['158'], // Andorra
  BA: ['159'], // Bosnia
  VA: ['160'], // Holy see (Vatican city state)
  IS: ['161'], // Iceland
  LI: ['162'], // Liechtenstein
  MC: ['163'], // Monaco
  ME: ['164'], // Montenegro
  MK: ['165'], // Macedonia
  SM: ['166'], // San Marino
  RS: ['167'], // Serbia
  AW: ['170'], // Aruba
  BS: ['172'], // Bahamas
  KY: ['179'], // Cayman Islands
  DM: ['180'], // Dominica
  FJ: ['183'], // Fiji
  GF: ['184'], // French Guiana
  PF: ['185'], // French Polynesia
  GU: ['188'], // Guam
  GY: ['189'], // Guyana
  MV: ['199'], // Maldives
  MQ: ['200'], // Martinique
  MS: ['205'], // Montserrat
  PG: ['209'], // Papua New Guinea
  PR: ['210'], // Puerto Rico
  NC: ['221'], // New Caledonia
  BN: ['243'], // Brunei
  MN: ['244'], // Mongolia

  // phase 7
  CM: ['79'], // Cameroon
  CG: ['82'], // Republic of Congo
  CI: ['85'], // Cote d'Ivoire
  RW: ['124'], // Rwanda
  SN: ['125'], // Senegal
  SO: ['130'], // Somalia
  UG: ['137'], // Uganda
  ZM: ['140'], // Zambia
  BW: ['176'], // Botswana
  GA: ['186'], // Gabon
  TN: ['217'], // Tunisia
  BJ: ['226'], // Benin
  BF: ['227'], // Burkina Faso
  NE: ['235'], // Niger
  AS: ['250'], // American Samoa
  AI: ['251'], // Anguilla
  BM: ['252'], // Bermuda
  VG: ['253'], // British Virgin Islands
  GI: ['254'], // Gibraltar
  MP: ['255'], // Northern Mariana Islands
  TC: ['256'], // Turks and Caicos Islands
  VI: ['257'], // United States Virgin Islands
  BB: ['258'], // Barbados
  BZ: ['259'], // Belize
  GD: ['260'], // Grenada
  JM: ['261'], // Jamaica
  MH: ['262'], // Marshall Islands
  KN: ['263'], // Saint Kitts and Nevis
  LC: ['264'], // Saint Lucia
  VC: ['265'], // Saint Vincent and the Grenadines
  SR: ['266'], // Suriname
  TO: ['267'], // Tonga
  GL: ['268'], // Greenland
  FO: ['269'], // Faroe Islands
  // 5[ & 6 phase
  SA: ['66'], // Saudi Arabia
  YE: ['69'], // Yemen
  ET: ['93'], // Ethiopia
  MW: ['109'], // Malawi
  TZ: ['132'], // Tanzania
  ZW: ['141'], // Zimbabwe
  DZ: ['168'], // Algeria
  AZ: ['171'], // Azerbaijan
  BH: ['173'], // Bahrain
  EG: ['181'], // Egypt
  IQ: ['190'], // Iraq
  IL: ['191'], // Israel
  LS: ['196'], // Lesotho
  LY: ['197'], // Libya
  MR: ['201'], // Mauritania
  MU: ['202'], // Mauritius
  MD: ['203'], // Moldova
  NA: ['206'], // Namibia
  OM: ['207'], // Oman
  QA: ['211'], // Qatar
  RE: ['212'], // Reunion
  SC: ['213'], // Seychelles
  TJ: ['215'], // Tajikistan
  GM: ['216'], // The Gambia
  AE: ['218'], // United Arab Emirates
  CD: ['230'], // Democratic Republic of the Congo
  GN: ['232'], // Guinea
  MG: ['234'], // Madagascar
  TG: ['237'], // Togo
  NG: ['242'], // Nigeria
  AM: ['245'], // Armenia
  GE: ['246'], // Georgia
  KG: ['248', '249'], // Kyrgyzstan
  // phase 8
  ER: ['91'], // Eritrea
  VU: ['270'], // Vanuatu
  WS: ['272'], // Samoa
  GW: ['273', '274'], // Guinea-Bissau
  PW: ['275'], // Palau
  CF: ['278', '279'], // Central African Republic
  KM: ['280', '281'], // Comoros
  WF: ['282'], // Wallis and Futuna
  CC: ['283'], // Cocos (Keeling) Islands
  CX: ['284'], // Christmas Island
  NR: ['285'], // Nauru
  CK: ['287'], // Cook Islands
  TV: ['288'], // Tuvalu
  NU: ['290'], // Niue
  TK: ['291'], // Tokelau
  NF: ['292'], // Norfolk Island
  PN: ['293'], // Pitcairn Islands
  AG: ['296'], // Antigua and Barbuda
  PM: ['297'], // Saint Pierre and Miquelon
  SL: ['298'], // Sierra Leone
  YT: ['301'], // Mayotte
  DJ: ['303', '304', '305'], // Djibouti
};

export const DistributionChannelToCountryNameMap = {
  DistributionChannelId_1: _TL_('United States'),
  DistributionChannelId_10: _TL_('Sweden'),
  DistributionChannelId_11: _TL_('New Zealand'),
  DistributionChannelId_115: _TL_('Nepal'),
  DistributionChannelId_12: _TL_('Singapore'),
  DistributionChannelId_120: _TL_('Panama'),
  DistributionChannelId_121: _TL_('Paraguay'),
  DistributionChannelId_13: _TL_('Malaysia'),
  DistributionChannelId_131: _TL_('Sri Lanka'),
  DistributionChannelId_135: _TL_('Trinidad and Tobago'),
  DistributionChannelId_139: _TL_('Uruguay'),
  DistributionChannelId_14: _TL_('Austria'),
  DistributionChannelId_142: _TL_('Turkey'),
  DistributionChannelId_143: _TL_('Poland'),
  DistributionChannelId_144: _TL_('Portugal'),
  DistributionChannelId_145: _TL_('Bulgaria'),
  DistributionChannelId_146: _TL_('Croatia'),
  DistributionChannelId_147: _TL_('Cyprus'),
  DistributionChannelId_148: _TL_('Czechia'),
  DistributionChannelId_149: _TL_('Estonia'),
  DistributionChannelId_15: _TL_('Spain'),
  DistributionChannelId_150: _TL_('Hungary'),
  DistributionChannelId_151: _TL_('Latvia'),
  DistributionChannelId_152: _TL_('Lithuania'),
  DistributionChannelId_153: _TL_('Malta'),
  DistributionChannelId_154: _TL_('Romania'),
  DistributionChannelId_155: _TL_('Slovakia'),
  DistributionChannelId_156: _TL_('Slovenia'),
  DistributionChannelId_157: _TL_('Albania'),
  DistributionChannelId_158: _TL_('Andorra'),
  DistributionChannelId_159: _TL_('Bosnia'),
  DistributionChannelId_160: _TL_('Holy See (vatican city state)'),
  DistributionChannelId_161: _TL_('Iceland'),
  DistributionChannelId_162: _TL_('Liechtenstein'),
  DistributionChannelId_163: _TL_('Monaco'),
  DistributionChannelId_164: _TL_('Montenegro'),
  DistributionChannelId_165: _TL_('Macedonia'),
  DistributionChannelId_166: _TL_('San Marino'),
  DistributionChannelId_167: _TL_('Serbia'),
  DistributionChannelId_17: _TL_('Mexico'),
  DistributionChannelId_170: _TL_('Aruba'),
  DistributionChannelId_172: _TL_('Bahamas'),
  DistributionChannelId_179: _TL_('Cayman Islands'),
  DistributionChannelId_18: _TL_('Taiwan'),
  DistributionChannelId_180: _TL_('Dominica'),
  DistributionChannelId_183: _TL_('Fiji'),
  DistributionChannelId_184: _TL_('French Guiana'),
  DistributionChannelId_185: _TL_('French Polynesia'),
  DistributionChannelId_188: _TL_('Guam'),
  DistributionChannelId_189: _TL_('Guyana'),
  DistributionChannelId_199: _TL_('Maldives'),
  DistributionChannelId_2: _TL_('Japan'),
  DistributionChannelId_19: _TL_('China'),
  DistributionChannelId_20: _TL_('Hong Kong'),
  DistributionChannelId_200: _TL_('Martinique'),
  DistributionChannelId_205: _TL_('Montserrat'),
  DistributionChannelId_209: _TL_('Papua New Guinea'),
  DistributionChannelId_21: _TL_('Netherlands'),
  DistributionChannelId_210: _TL_('Puerto Rico'),
  DistributionChannelId_22: _TL_('Brazil'),
  DistributionChannelId_221: _TL_('New Caledonia'),
  DistributionChannelId_23: _TL_('Italy'),
  DistributionChannelId_24: _TL_('Switzerland - DE'),
  DistributionChannelId_243: _TL_('Brunei'),
  DistributionChannelId_244: _TL_('Mongolia'),
  DistributionChannelId_26: _TL_('Belgium'),
  DistributionChannelId_28: _TL_('Finland'),
  DistributionChannelId_29: _TL_('Denmark'),
  DistributionChannelId_3: _TL_('United Kingdom'),
  DistributionChannelId_30: _TL_('Norway'),
  DistributionChannelId_31: _TL_('South Africa'),
  DistributionChannelId_32: _TL_('India'),
  DistributionChannelId_35: _TL_('Ireland'),
  DistributionChannelId_39: _TL_('Greece'),
  DistributionChannelId_4: _TL_('Australia'),
  DistributionChannelId_40: _TL_('Argentina'),
  DistributionChannelId_41: _TL_('Colombia'),
  DistributionChannelId_42: _TL_('Chile'),
  DistributionChannelId_43: _TL_('Venezuela'),
  DistributionChannelId_44: _TL_('Peru'),
  DistributionChannelId_5: _TL_('Germany'),
  DistributionChannelId_50: _TL_('Luxembourg'),
  DistributionChannelId_51: _TL_('Philippines'),
  DistributionChannelId_52: _TL_('Vietnam'),
  DistributionChannelId_53: _TL_('Thailand'),
  DistributionChannelId_54: _TL_('Indonesia'),
  DistributionChannelId_6: _TL_('France'),
  DistributionChannelId_7: _TL_('Canada'),
  DistributionChannelId_72: _TL_('Bangladesh'),
  DistributionChannelId_74: _TL_('Bolivia'),
  DistributionChannelId_84: _TL_('Costa Rica'),
  DistributionChannelId_88: _TL_('Dominican Republic\r\n  '),
  DistributionChannelId_89: _TL_('Ecuador'),
  DistributionChannelId_90: _TL_('El Salvador'),
  DistributionChannelId_95: _TL_('Guatemala'),
  DistributionChannelId_97: _TL_('Haiti'),
  DistributionChannelId_98: _TL_('Honduras'),
  DistributionChannelId_79: _TL_('Cameroon'),
  DistributionChannelId_82: _TL_('Republic of Congo'),
  DistributionChannelId_85: _TL_("Cote d'Ivoire"),
  DistributionChannelId_124: _TL_('Rwanda'),
  DistributionChannelId_125: _TL_('Senegal'),
  DistributionChannelId_130: _TL_('Somalia'),
  DistributionChannelId_137: _TL_('Uganda'),
  DistributionChannelId_140: _TL_('Zambia'),
  DistributionChannelId_176: _TL_('Botswana'),
  DistributionChannelId_186: _TL_('Gabon'),
  DistributionChannelId_217: _TL_('Tunisia'),
  DistributionChannelId_226: _TL_('Benin'),
  DistributionChannelId_227: _TL_('Burkina Faso'),
  DistributionChannelId_235: _TL_('Niger'),
  DistributionChannelId_250: _TL_('American Samoa'),
  DistributionChannelId_251: _TL_('Anguilla'),
  DistributionChannelId_252: _TL_('Bermuda'),
  DistributionChannelId_253: _TL_('British Virgin Islands'),
  DistributionChannelId_254: _TL_('Gibraltar'),
  DistributionChannelId_255: _TL_('Northern Mariana Islands'),
  DistributionChannelId_256: _TL_('Turks and Caicos Islands'),
  DistributionChannelId_257: _TL_('United States Virgin Islands'),
  DistributionChannelId_258: _TL_('Barbados'),
  DistributionChannelId_259: _TL_('Belize'),
  DistributionChannelId_260: _TL_('Grenada'),
  DistributionChannelId_261: _TL_('Jamaica'),
  DistributionChannelId_262: _TL_('Marshall Islands'),
  DistributionChannelId_263: _TL_('Saint Kitts and Nevis'),
  DistributionChannelId_264: _TL_('Saint Lucia'),
  DistributionChannelId_265: _TL_('Saint Vincent and the Grenadines'),
  DistributionChannelId_266: _TL_('Suriname'),
  DistributionChannelId_267: _TL_('Tonga'),
  DistributionChannelId_268: _TL_('Greenland'),
  DistributionChannelId_269: _TL_('Faroe Islands'),
  DistributionChannelId_66: _TL_('Saudi Arabia'),
  DistributionChannelId_69: _TL_('Yemen'),
  DistributionChannelId_93: _TL_('Ethiopia'),
  DistributionChannelId_109: _TL_('Malawi'),
  DistributionChannelId_132: _TL_('Tanzania'),
  DistributionChannelId_141: _TL_('Zimbabwe'),
  DistributionChannelId_168: _TL_('Algeria'),
  DistributionChannelId_171: _TL_('Azerbaijan'),
  DistributionChannelId_173: _TL_('Bahrain'),
  DistributionChannelId_181: _TL_('Egypt'),
  DistributionChannelId_190: _TL_('Iraq'),
  DistributionChannelId_191: _TL_('Israel'),
  DistributionChannelId_196: _TL_('Lesotho'),
  DistributionChannelId_197: _TL_('Libya'),
  DistributionChannelId_201: _TL_('Mauritania'),
  DistributionChannelId_202: _TL_('Mauritius'),
  DistributionChannelId_203: _TL_('Moldova'),
  DistributionChannelId_206: _TL_('Namibia'),
  DistributionChannelId_207: _TL_('Oman'),
  DistributionChannelId_211: _TL_('Qatar'),
  DistributionChannelId_212: _TL_('Reunion'),
  DistributionChannelId_213: _TL_('Seychelles'),
  DistributionChannelId_215: _TL_('Tajikistan'),
  DistributionChannelId_216: _TL_('The Gambia'),
  DistributionChannelId_218: _TL_('United Arab Emirates'),
  DistributionChannelId_230: _TL_('Democratic Republic of the Congo'),
  DistributionChannelId_232: _TL_('Guinea'),
  DistributionChannelId_234: _TL_('Madagascar'),
  DistributionChannelId_237: _TL_('Togo'),
  DistributionChannelId_242: _TL_('Nigeria'),
  DistributionChannelId_245: _TL_('Armenia'),
  DistributionChannelId_246: _TL_('Georgia'),
  DistributionChannelId_248: _TL_('Kyrgyzstan'),
  DistributionChannelId_249: _TL_('Kyrgyzstan'),
  DistributionChannelId_91: _TL_('Eritrea'),
  DistributionChannelId_270: _TL_('Vanuatu'),
  DistributionChannelId_272: _TL_('Samoa'),
  DistributionChannelId_273: _TL_('Guinea-Bissau'),
  DistributionChannelId_274: _TL_('Guinea-Bissau'),
  DistributionChannelId_275: _TL_('Palau'),
  DistributionChannelId_278: _TL_('Central African Republic'),
  DistributionChannelId_279: _TL_('Central African Republic'),
  DistributionChannelId_280: _TL_('Comoros'),
  DistributionChannelId_281: _TL_('Comoros'),
  DistributionChannelId_282: _TL_('Wallis and Futuna'),
  DistributionChannelId_283: _TL_('Cocos (Keeling) Islands'),
  DistributionChannelId_284: _TL_('Christmas Island'),
  DistributionChannelId_285: _TL_('Nauru'),
  DistributionChannelId_287: _TL_('Cook Islands'),
  DistributionChannelId_288: _TL_('Tuvalu'),
  DistributionChannelId_290: _TL_('Niue'),
  DistributionChannelId_291: _TL_('Tokelau'),
  DistributionChannelId_292: _TL_('Norfolk Island'),
  DistributionChannelId_293: _TL_('Pitcairn Islands'),
  DistributionChannelId_296: _TL_('Antigua and Barbuda'),
  DistributionChannelId_297: _TL_('Saint Pierre and Miquelon'),
  DistributionChannelId_298: _TL_('Sierra Leone'),
  DistributionChannelId_301: _TL_('Mayotte'),
  DistributionChannelId_303: _TL_('Djibouti'),
  DistributionChannelId_304: _TL_('Djibouti'),
  DistributionChannelId_305: _TL_('Djibouti'),
};

export const listSizeConst = {
  minimumListSize: 1000,
  minimumEligibleAudienceSize: 300,
};

export const InMarketInternalization = {
  SearchNetwork: 'BingAds',
  AudienceNetwork: 'AIM',
  SearchChannel: 'bulk-search',
  AudienceChannel: 'bulk-audience',
};
